import React, { useEffect, useState } from "react";
import { TableCustom } from "../../components/Table";
import { TABLE_COLUMN_REPORT_TYPES } from "../../helper";
import useAxiosInstance from "../../hooks/useAxios";
import { Paginator } from "../../components/Paginator";
import Input from "../../components/input";
import { useDebounce } from "use-debounce";
import { useSelector } from "react-redux";
import ReactSelect from "react-select";
import { Link, useNavigate } from "react-router-dom";

const AllReportTypes = () => {
  const axiosInstance = useAxiosInstance();
  const { allReportCategory } = useSelector((e) => e.globalAuth);
  const history = useNavigate();
  const [response, setResponse] = useState({ data: [] });
  const [query, setQuery] = useState("");
  const [extraKeys, setExtraKeys] = useState([]);
  const [reportCategory, setReportCategory] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [pageIntermidiate, setPageIntermidiate] = useState(1);
  const [loading, setLoading] = useState(false);
  const [userQuery] = useDebounce(query, 1000);

  useEffect(() => {
    setLoading(true);
    axiosInstance
      .post("/accounts/all_report_types/", {
        page: page,
        page_size: pageSize,
        search_query: userQuery,
        report_category: reportCategory,
        extra_boolean_keys: extraKeys,
      })
      .then((res) => {
        setLoading(false);
        const newData = [];
        res.data.data.forEach((reportType) => {
          newData.push({ ...reportType, id: reportType.pk });
        });
        setResponse({ ...res.data, data: newData });
        setPageIntermidiate(res.data.current_page);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [page, pageSize, userQuery, reportCategory, extraKeys]);

  return (
    <div className="h-screen mr-2 overflow-y-auto">
      <div className="flex justify-between px-2 py-2 my-2 bg-white border rounded-lg">
        <p className="text-base font-semibold">Report Types</p>
        <div>
          <Link to="/report-preview">Preview</Link>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-3">
        <div className="">
          <p className="mb-2 text-sm font-semibold">Select Category</p>
          <ReactSelect
            className="w-full"
            options={allReportCategory.map((elem) => ({
              label: elem.label,
              value: elem.pk,
            }))}
            isMulti
            value={allReportCategory
              .map((elem) => ({
                label: elem.label,
                value: elem.pk,
              }))
              .filter((item) => reportCategory.includes(item.value))}
            onChange={(e) => {
              setReportCategory(e.map((it) => it.value));
            }}
          />
        </div>

        <div className="">
          <p className="mb-2 text-sm font-semibold">Search by label</p>
          <Input
            type={"text"}
            value={query}
            placeholder={"Search by label"}
            onChange={(e) => {
              setQuery(e.target.value);
            }}
          />
        </div>

        <div className="">
          <p className="mb-2 text-sm font-semibold">Extra key filters</p>
          <ReactSelect
            className="w-full"
            options={["is_sandbox", "active"].map((elem) => ({
              label: elem,
              value: elem,
            }))}
            isMulti
            value={["is_sandbox", "active"]
              .map((elem) => ({
                label: elem,
                value: elem,
              }))
              .filter((item) => extraKeys.includes(item.value))}
            onChange={(e) => {
              setExtraKeys(e.map((it) => it.value));
            }}
          />
        </div>
      </div>
      <div>
        <TableCustom
          columns={TABLE_COLUMN_REPORT_TYPES}
          data={{ data: response.data }}
          loading={loading}
          handleEdit={(id) => {
            history(`/edit-report-type/${id}`);
          }}
          handleDelete={null}
          handleSelect={null}
          className="max-w-full h-[60vh] !max-h-[60vh]"
        />
        <Paginator
          data={response}
          intermidiatePageNumber={pageIntermidiate}
          loading={loading}
          pageSize={pageSize}
          setIntermidiatePageNumber={setPageIntermidiate}
          setPage={setPage}
          setPageSize={setPageSize}
        />
      </div>
    </div>
  );
};

export default AllReportTypes;
